// FrameX canvas colours.
//
// --fx-manual also lives in src/assets/styles/framex.scss, which is where the DOM
// chrome reads its tokens. Canvas drawing cannot resolve CSS custom properties, so
// the overlay paint path takes its values from here instead of re-typing the hex.

/**
 * Outline around a sheet that is in the FrameX working set. Tailwind yellow-500,
 * one of the swatches in the app's own colour picker (`lib/sidebar/ColorInput.svelte`),
 * so it reads as the same yellow family as the amber chips and page-number tiles.
 *
 * The yellow scale rather than the amber one: amber-800 read as brown and amber-500
 * as orange. Distinct from the frame-marker fill (`--fx-manual`, #fcd34d) so a
 * sheet's outline never matches the frame boxes drawn inside it.
 */
export const FRAMEX_PAGE_OUTLINE = "#EAB308";
